<template>
    <div class="animation_input">
        <el-select class="input" v-model="val" style="width: 100%" size="large" placeholder=" " clearable @change="handleChange">
            <el-option v-for="item in options" :key="item" :label="item.name" :value="item.id" />
        </el-select>
        <label class="label_name" :class="modelValue ? 'small' : ''" :for="name">{{ placeholder }}</label>
    </div>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from "vue";

const props = defineProps({
    modelValue: { type: String, default: "" },
    name: { type: String, requied: true },
    placeholder: { type: String, default: "" },
    options: { type: Array, default: () => [] },
});
const emit = defineEmits(["update:modelValue"]);
const val = ref("");

function handleChange() {
    emit("update:modelValue", val.value);
}

onMounted(() => {
    val.value = props.modelValue;
});
</script>

<style lang="scss" scoped>
.animation_input {
    width: 100%;
    position: relative;
    border-bottom: 1px solid #d8d8d8;
    height: 68px;
    transition: all 0.3s linear;

    &:has(.input:focus) {
        border-bottom: 2px solid var(--week-primary-color);
    }

    .label_name {
        position: absolute;
        left: 5px;
        top: 20px;
        font-size: 16px;
        color: #727272;
        transition: all 0.3s linear;
        cursor: text;

        &.small {
            top: 0;
            left: 0;
            font-size: 14px;
        }
    }

    .input {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        background: none;
        border: none;
        font-size: 16px;
        color: #727272;

        &:focus {
            & + .label_name {
                top: 0;
                left: 0;
                color: var(--week-primary-color);
                font-size: 14px;
            }
        }

        /* 去掉填充后的背景色*/
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
            -webkit-transition-delay: 111111s;
            -webkit-transition: color 11111s ease-out, background-color 111111s ease-out;
        }
        :deep(.el-input__inner) {
            border: none;
            padding-left: 5px;
            font-size: 16px;
        }
    }

    .code_img {
        width: 90px;
        height: 32px;
        border: 1px solid #d9d9d9;
        position: absolute;
        bottom: 10px;
        right: 0;
        cursor: pointer;
    }
}
</style>
